import { makeStyles } from "@material-ui/styles";
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  segment: {
    display: "flex",
    height: "100%",
    zIndex: 3,
  },
  cell: {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
    justifyContent: "center",
    width: CELL_WIDTHS.VALUE.SMALL,
    height: "100%",
    borderRight: "1px solid transparent",
  },
  cellBilling: {
    alignItems: "flex-end",
  },
}));

export default useStyle;
